import { useVarsityAppConfig } from "./useVarsityAppConfig"

export function useMediaUrl() {
    const { appConfig } = useVarsityAppConfig()

    function mediaUrl(path: string): string {
        const normalizedPath = path.replace(/^\//, "")
        const prefix = appConfig.value?.mediaUrlPrefix ?? "/media-library"
        return prefix + "/" + normalizedPath
    }

    function uploadCdnUrl(filename: string): string {
        const prefix = appConfig.value?.uploadCdnUrlPrefix ?? "/public-media"
        const dir1 = filename.substring(0, 2)
        const dir2 = filename.substring(2, 4)
        return `${prefix}/${dir1}/${dir2}/${filename}`
    }

    return { mediaUrl, uploadCdnUrl }
}
